// JS
require('./init.js');
// Sass
require('./../sass/index.sass');